<template>
  <div
    class="w-full h-auto pb-[3.75vw] bg-[linear-gradient(to_bottom,#FFFFFF_70%,#F5F5F7_30%)]"
  >
    <!-- 标题区域 -->
    <div
      class="relative w-full h-auto mx-auto mb-[2vw] flex flex-col justify-center gap-[0.42vw]"
    >
      <!-- 主标题框 -->
      <div class="h-[3.3vw] flex flex-col justify-center items-center">
        <div
          class="text-[2.71vw] text-[#1A2233] font-harmony font-bold leading-[3.25vw] text-center"
        >
          申请试听
        </div>
      </div>
      <!-- 副标题框 -->
      <div class="h-[3vw] flex flex-col justify-center items-center">
        <div
          class="text-[1.25vw] text-[#9CA3AF] font-harmony font-normal leading-[2.97vw] text-center"
        >
          仅需30秒填写，开启孩子的航空科技之旅
        </div>
      </div>
    </div>
    <!-- 描述文字区域 -->

    <!-- 表单区域 -->
    <div
      class="w-[61.46vw] h-[12.14vw] px-[14.83vw] py-[2.60vw] bg-[#05358c] rounded-2xl flex flex-col justify-between mx-auto"
    >
      <Form />

      <!-- 提示文本 -->
      <div class="flex flex-row gap-[0.3vw]">
        <div
          class="w-auto h-[2.5vw] flex text-white text-[0.63vw] leading-[1.25vw] font-light font-harmony"
        >
          您将获得:
        </div>
        <div
          class="w-auto h-[2.5vw] flex text-white text-[0.63vw] leading-[1.25vw] font-light font-harmony"
        >
          1.免费1V1课程规划咨询<br />
          2.试听当日赠飞行训练礼包（含教具）
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/components/FormSubmit/Form.vue";

export default {
  name: "coursesystem-module7",
  components: {
    Form,
  },
};
</script>

<style scoped>
</style>